"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCorrectCssTransition = void 0;
const react_1 = require("react");
function withoutTransition(callback) {
    const css = document.createElement('style');
    css.appendChild(document.createTextNode(`* {
       -webkit-transition: none !important;
       -moz-transition: none !important;
       -o-transition: none !important;
       -ms-transition: none !important;
       transition: none !important;
    }`));
    document.head.appendChild(css);
    callback();
    setTimeout(() => {
        // Calling getComputedStyle forces the browser to redraw
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _ = window.getComputedStyle(css).transition;
        document.head.removeChild(css);
    }, 0);
}
function useCorrectCssTransition({ disableTransitions = false, } = {}) {
    return (0, react_1.useCallback)((callback) => {
        if (disableTransitions) {
            withoutTransition(() => {
                callback();
            });
        }
        else {
            callback();
        }
    }, [disableTransitions]);
}
exports.useCorrectCssTransition = useCorrectCssTransition;
